import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FurnitureInstance } from "@/state/Furniture";
import { DoorStateMachine } from "@/3d/animation/DoorStateMachine";
import { Row } from "@/dom/components/Panel/Row";
import { Typography } from "@/dom/components/Typography/Typography";
import { Switch } from "@/dom/components/Switch/Switch";

type FurnitureElementsViewProps = {
    instance: FurnitureInstance;
};

export const FurnitureElementsView: React.FC<FurnitureElementsViewProps> = ({ instance }) => {
    const doorStateMachines: DoorStateMachine[] = useMemo(() => {
        return instance.instance.groups
            .map((group) => group.stateMachine)
            .filter((machine): machine is DoorStateMachine => {
                return machine !== undefined && machine instanceof DoorStateMachine;
            });
    }, [instance.instance.groups]);

    const [isOpen, setIsOpen] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        const handleAvailableActionsChange = () => {
            const areAllDoorsClosed = doorStateMachines.every(
                (machine) => machine.state === "closed"
            );
            const areAllDoorsOpen = doorStateMachines.every((machine) => machine.state === "open");
            setIsOpen(areAllDoorsOpen);
            setIsEnabled(areAllDoorsClosed || areAllDoorsOpen);
        };

        doorStateMachines.forEach((machine) => {
            machine.on("availableActionsChange", handleAvailableActionsChange);
        });

        handleAvailableActionsChange();

        return () => {
            doorStateMachines.forEach((machine) => {
                machine.off("availableActionsChange", handleAvailableActionsChange);
            });
        };
    }, [doorStateMachines]);

    const toggleDoors = useCallback(() => {
        if (isOpen) {
            doorStateMachines.forEach((machine) => machine.startClosing());
        } else {
            doorStateMachines.forEach((machine) => machine.startOpening());
        }
    }, [isOpen, doorStateMachines]);

    if (doorStateMachines.length > 0) {
        return (
            <Row>
                <Typography variant="subtitle">Дверцы</Typography>
                <Row>
                    <Switch checked={isOpen} onChange={toggleDoors} disabled={!isEnabled} />
                    <span>Открыть дверцы</span>
                </Row>
            </Row>
        );
    }

    return null;
};
